import * as zod from "zod";

const CampaignMessageSchema_ = zod.object({
  _id: zod.string(),
  campaignId: zod.string(),
  campaignName: zod.string(),
  linearTicketId: zod.string(),
  linearTicketIdentifier: zod.string(),
  linearTicketUrl: zod.string(),
  slackChannel: zod.string(),
  slackMessageTs: zod.string(),
  messageTitle: zod.string(),
  messageSummary: zod.string(),
  sentAt: zod.string(),
});

export const CampaignMessageSchema: zod.ZodType<CampaignMessage> =
  CampaignMessageSchema_;
export interface CampaignMessage
  extends zod.infer<typeof CampaignMessageSchema_> {}

export const getCampaignMessages = {
  name: "getCampaignMessages" as const,
  input: zod.object({
    campaignId: zod.string(),
    limit: zod.number().optional(),
    offset: zod.number().optional(),
  }),
  output: zod.object({
    messages: zod.array(CampaignMessageSchema),
    total: zod.number(),
  }),
};
